'use client';

import Image from 'next/image';
import Container from '../../../components/Container';
import { useExternalRedirectAnalytics } from '../../../hooks/Analytics/useExternalRedirectAnalytics';
import styles from './styles.module.scss';
import SocialIconLink from '../../../components/SocialIconLink';
import { FunctionComponent } from 'react';

export const Contact: FunctionComponent = () => {
    const { recordRedirect } = useExternalRedirectAnalytics();

    return (
        <Container>
            <main className={styles.contact_container}>
                <section className={styles.get_in_touch_section}>
                    <div className={styles.get_in_touch_text_content}>
                        <h1>Get In Touch</h1>
                        <p>
                            Whether you are looking for more information about our platform or have
                            a questions about the company, please don&apos;t hesitate to reach out.
                            We are always happy to help! Use any of the methods below to contact us
                            and we will get back to you ASAP.
                        </p>
                    </div>
                    <div className={styles.get_in_touch_section_image}>
                        <Image
                            src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/images/owls/400/letter.png`}
                            alt="Contact Cademy"
                            fill
                            priority={true}
                            sizes="max-width(640px) 100vw, 60vw"
                        />
                    </div>
                </section>
                <section className={styles.contact_info_section}>
                    <section className={styles.emails_and_numbers}>
                        <h2>Email</h2>
                        <p>
                            General Enquiries:{' '}
                            <a
                                href={`mailto:${process.env.NEXT_PUBLIC_CADEMY_GENERAL_EMAIL_ADDRESS}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Email general enquiries"
                            >
                                {process.env.NEXT_PUBLIC_CADEMY_GENERAL_EMAIL_ADDRESS}
                            </a>
                        </p>
                        <p>
                            Support:{' '}
                            <a
                                href={`mailto:${process.env.NEXT_PUBLIC_CADEMY_SUPPORT_EMAIL_ADDRESS}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Email support"
                            >
                                {process.env.NEXT_PUBLIC_CADEMY_SUPPORT_EMAIL_ADDRESS}
                            </a>
                        </p>
                        <h2>Phone</h2>
                        <p>
                            US Sales & Support:{' '}
                            <a
                                href="tel:+18459990515"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Call Cademy US Office"
                            >
                                +1 845 999 0515
                            </a>
                        </p>
                        <p>
                            UK Sales & Support:{' '}
                            <a
                                href="tel:+441315105645"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Call Cademy UK Office"
                            >
                                +44 131 510 5645
                            </a>
                        </p>
                        <h2 id="cademy-socials-header">Socials</h2>
                        <ul
                            className={styles.social_icons_list}
                            aria-labelledby="cademy-socials-header"
                        >
                            <SocialIconLink
                                href={'https://twitter.com/cademy__'}
                                preset="twitter"
                                recordRedirect={recordRedirect}
                            />
                            <SocialIconLink
                                href={'https://www.facebook.com/cademy.co.uk'}
                                preset="facebook"
                                recordRedirect={recordRedirect}
                            />
                            <SocialIconLink
                                href={'https://www.linkedin.com/company/cademy-io'}
                                preset="linkedin"
                                recordRedirect={recordRedirect}
                            />
                        </ul>
                    </section>
                    <section className={styles.address_and_socials}>
                        <h2>Address</h2>
                        <strong>Edinburgh Office</strong>
                        <address>
                            Cademy Group Ltd,
                            <br />
                            Floor 1, 27 Queen Charlotte Street,
                            <br />
                            Edinburgh,
                            <br />
                            EH6 6AX,
                            <br />
                            United Kingdom
                        </address>
                        <br />
                        <br />
                        <strong>New York Office</strong>
                        <address>
                            Cademy,
                            <br />
                            447 Broadway, 2nd Floor #1386,
                            <br />
                            New York, NY 10013
                            <br />
                            United States
                        </address>
                    </section>
                </section>
            </main>
        </Container>
    );
};
